/* eslint-disable max-len */
export default {
    controls: {
        profile: 'Perfil',
        next: 'Siguiente',
        previous: 'Anterior',
        goback: 'Atrás',
        close: 'Cerca',
    },
    landing: {
        banner: {
            title: '¡Lo mejor de Cartoon Network en un solo lugar!',
            text:
                'Desde Cartoon Network app podrás disfrutar de tus show favoritos, como Ben 10, Hora de Aventura, Las Chicas Superpoderosas, Osos Escandalosos, Los Jóvenes Titanes en Acción y más.',
            button: 'Saber más',
        },
        shows: {
            title: '¡Mira tus shows favoritos cuando quieras!',
            text:
                'Ve nuestros shows desde tu teléfono, tablet, computadora portátil y TV sin pagar de más.',
        },
        benefits: {
            title: {
                part1: 'Mucho más Cartoon Network',
                part2: 'para que lo disfrutes',
            },
            feature1: {
                title: 'Episodios completos',
                text: '¡Mira episodios completos de Gumball, Ben 10 y más!',
            },
            feature2: {
                title: 'Mantente actualizado',
                text:
                    '¿Te perdiste un capítulo de El Tren Infinito? ¡Mira los show más nuevos aquí!',
            },
            feature3: {
                title: 'Estrenos exclusivos',
                text: '¿Nuevos shows? ¡Podrás verlos primero aquí!',
            },
        },
        login: 'LOGIN',
        help: 'Necesito ayuda',
        skip: 'Más tarde',
        available: 'Também disponível para download',
    },
    walkthrough: {
        page1: {
            title: '¡Quiero entrar!',
            text:
                'Accede a Cartoon Network App a través de nuestros proveedores y cable operadores',
        },
        page2: {
            title: '¿Tengo que pagar algo?',
            text:
                'Eso depende del plan que tengas con el proveedor o cable operador. ¡Revisa nuestro centro de ayuda!',
        },
        page3: {
            title: 'Originales de Cartoon Network y más',
            text:
                '¡Tus shows favoritos en un solo lugar!¡Temporadas completas y episodios nuevos para ver cuando quieras!',
        },
    },
    login: {
        title:
            'Por favor, si no eres un adulto, pide ayuda con el proceso de registro',
        continue: 'CONTINUAR',
        help_title: 'Por favor pida ayuda',
        help_subtitle:
            'Asegúrate de pedirle a mamá o papá que te ayuden con esto.',
    },
    AAA: {
        title: 'Primero, ¿estás subscripto a CN?',
        subtitle: 'Selecciona tu proveedor o cable operador debajo',
        failure:
            'No tienes acceso a este contenido. En caso de duda, contacte a su operador.',
    },
    favorites: {
        title: 'Favoritos',
        shows: 'Shows Favoritos',
        episodes: 'Episodios Favoritos',
        noContent: 'NO TIENES SHOWS O EPISODIOS AGREGADOS A FAVORITOS',
        noShowTitle: 'NO TIENES SHOWS AGREGADOS A FAVORITOS',
        noEpisodeTitle: 'NO TIENES EPISODIOS AGREGADOS A FAVORITOS',
        description1:
            '¡Adelante! Empieza a agregar tus shows y episodios favoritos. Solo tienes que tocar el ',
        description2: ' y aparecerán aquí',
    },
    footerV2: {
        description:
            '¡Bienvenidos al sitio oficial de Cartoon Network! Aquí encontrarás los mejores dibujos animados, juegos gratis, transmisiones en vivo con episodios completos, entre otras novedades, todos los días. Series como Ben 10, Los Jóvenes Titanes en Acción, Scooby Doo, Tom & Jerry, El mundo de Craig, Looney Tunes, Manzana y Cebollín, Villanos, El Increíble Mundo de Gumball y más. \n\n Con Cartoonito, padres e hijos pueden conocer lo mejor del contenido preescolar. Mira clips y otras series de forma segura. ¿Tienes algo que decirnos? Chatea con nosotros hola@cartoonnetwork.com',
        downloadApp:
            '¡Descarga la aplicación ahora y asegura diversión para toda la familia!',
        privacyPolicy: 'Politica de Privacidad',
        termsOfUse: 'Términos de Uso',
        FAQandHelp: 'FAQ y Ayuda',
        schedule: 'Programación Cartoon Network',
        scheduleCNito: 'Programación Cartoonito',
        preferencesPanel: 'Painel de Preferências',
        disclaimer:
            'El uso de este sitio web implica que usted acepta los Términos de Uso. TM & © 2023 Cartoon Network. Una compañía de Warner Bros Discovery. Todos los derechos reservados. CartoonNetwork App es parte de la Red Digital de Deportes y Entretenimiento de Turner.',
        cookies: 'Gestionar Cookies',
    },
    home: {
        title: 'Home',
        watchNext: 'VER A CONTINUACIÓN',
        recommended: 'RECOMENDADO',
        mostWatched: 'LO MÁS VISTO',
        comedy: 'COMEDIA',
        adventure: 'AVENTURA',
        newReleases: 'NUEVOS LANZAMIENTOS',
        metaTitle:
            'Cartoon Network App - ¡Mira dibujos animados y shows exclusivos!',
        metaDescription:
            'Lo mejor de Cartoon Network en un solo lugar. Mira shows como Ben 10, Hora de Aventura, Steven Universe, Las chicas superpoderosas y mucho más!',
        games: 'MEJORES JUEGOS',
    },
    shows: {
        title: 'Cartoons',
        about: 'SOBRE',
        season: 'TEMPORADA',
        minisodes: 'Minisodios',
        shorts: 'Cortos',
        similar: 'SHOWS SIMILARES',
        favorited: 'Show agregado a favoritos',
        unfavorited: 'Show removido',
    },
    onnow: {
        title: 'En Vivo',
        previewTitle: 'Cartoon Network TV',
        previewSubtitle:
            '¡Mira tus dibujos animados y programas de televisión favoritos! Directamente en la aplicación CN donde y cuando sea, para que nunca te pierdas los últimos shows',
        previewCTA: 'Empieza a mirar',
        geoblockError:
            'Parece que no estás en el país correcto para poder ver este contenido con tu cuenta.',
        seoLiveTitle:
            'Assista en vivo en Cartoon Network nuestros originales digitales',
        seoLiveDescription:
            'Transmisión en vivo de nuestro contenido original que solo puede ver aquí en Cartoon Network. ¡Encontrarás episodios de contenido original de sus favoritos como Gumball, Steven Universe y más!',
    },
    onnowV2: {
        tabTitle: 'En Vivo',
        title: 'Mira shows en vivo',
        subtitle:
            'Disfruta del canal en vivo de Cartoon Network y transmisiones en vivo exclusivas.',
        subtitleNoTV: 'Disfruta de transmisiones en vivo exclusivas.',
        liveTV: 'TV en vivo',
        livestream: 'Livestream',
        liveNow: 'En vivo ahora',
        liveTVTitle: 'Cartoon Network TV',
        notificationsDisabledTitle:
            'Activa las notificaciones y te informaremos sobre las nuevas transmisiones en vivo.',
        notificationsAction: 'Envíame notificaciones',
        emptyTitle: 'No hay nada vivo ahora mismo',
        emptySubTitle:
            'Vuelve más tarde para ver si hay transmisiones en vivo están a punto de empezar.',
        emptySubtitleNoNotification:
            'Activa las notificaciones para novedades acerca de shows y transmisiones en vivo.',
        notificationsEnabledTitle: 'Te notificaremos cuando haya novedades.',
    },
    movies: {
        title: 'Películas',
    },
    video: {
        upNext: 'A CONTINUACIÓN',
        autoplay: 'Autoplay',
        recommended: 'PUEDE GUSTARTE',
        episode: 'Episodio',
        concurrencyError:
            'Tienes demasiados dispositivos logueados al mismo tiempo. Por favor, desloguéate de otro dispositivo para continuar.',
        favorited: 'Episodio agregado a favoritos',
        unfavorited: 'Episodio removido',
        titleFormat: 'T{season}:E{episode}',
        findOut: 'Ver más de este show',
        noContent: 'No hay contenido disponible',
    },
    killSwitch: {
        updateRequired: {
            title: 'Actualización necesaria',
            subtitle:
                'Debido a cuestiones de seguridad, necesitas actulizar la app a la versión más reciente',
            cta: 'ACTUALIZAR AHORA',
        },
        serviceError: {
            title: 'Algo ha salido mal...',
            subtitle:
                'Ha ocurrido un error y estamos trabajando para resolverlo.',
        },
        updateOptional: {
            title: 'Nueva versión disponible',
            subtitle:
                '¡Hay una nueva versión disponible para descargar! Por favor actualiza la app en el Store',
            cta: 'ACTUALIZAR AHORA',
            skip: 'Ahora No',
        },
    },
    error: {
        title: 'OH OH',
        subtitle: 'Algo ha salido mal...',
        cta: 'Volver',
        cnito: {
            title: 'Oops! Algo ha salido mal',
            subtitle:
                'Vuelva a intentarlo más tarde, estamos tratando de solucionarlo.',
        },
    },
    logout: {
        message: '¿Realmente quieres desloguearte?',
        confirm: 'Sí',
        cancel: 'Cancelar',
    },
    drawer: {
        pushNotifications: 'Notificaciones Push',
        logout: 'Desloguearse',
    },
    pushNudge: {
        title: 'No te quedes afuera',
        subtitle1:
            'Activa notificaciones sobre shows y otros servicios. Haz click en el ícono de ',
        subtitle2: ' para activar y desactivar, si cambias de parecer.',
        disclaimer: 'Por favor, chequea con un adulto si esto está bien.',
        cta: 'PERMITIR NOTIFICACIONES',
        skip: 'Ahora No',
    },
    notifications: {
        title: 'Notificaciones',
        text:
            'Cartoon Network puede notificarle sobre los últimos programas y otros servicios en sus dispositivos móviles',
        disclaimer: 'Por favor, chequea con un adulto si esto está bien.',
        switchTitle: 'Envíame notificaciones automáticas',
    },
    mobileData: {
        title: 'Datos Móviles',
        subtitle:
            'Cartoon Network puede reproducir videos a través de WIFI y datos móviles, pero reproducir a través de datos podría costarle dinero',
        disclaimer:
            '¿Podemos desactivar la reproducción de videos con sus datos si eso ayuda?',
        switchLabel: 'Habilitar la reproducción de videos con datos',
        modalTitle:
            '¡Oh, no! Actualmente no tienes habilitados tus datos móviles',
        modalSubtitle:
            'Para reproducir videos usando sus datos, vaya a la configuración y habilite la reproducción de datos',
        modalCTA: 'Configuración',
        modalSkip: 'Esperaré hasta tener WIFI',
    },
    lockedContent: {
        homeText: '¡INICIA SESIÓN PARA VER EPISODIOS COMPLETOS!',
        showText: '¡INICIA SESIÓN PARA VER EPISODIOS COMPLETOS!',
        favoriteText: '¡INICIA SESIÓN PARA VER EPISODIOS COMPLETOS!',
        unlockShow: 'DESBLOQUEAR EPISODIOS COMPLETOS DE {{show_title}}',
        shows: {
            title: 'VER MÁS',
            subtitle:
                'Inicia sesión para ver episodios completos de tus shows favoritos',
            cta: 'INGRESA AHORA',
        },
        playback: {
            title: 'EPISODIOS COMPLETOS',
            subtitle:
                'Inicia sesión para acceder y ver episodios completos de tus shows favoritos',
            cta: 'INGRESA AHORA',
        },
        interstitial: {
            title: 'DESBLOQUEA MÁS CONTENIDO',
            subtitle: 'Regístrate a través de tu proveedor de cable',
            item1: 'Más Shows',
            item2: 'Episodios recientes',
            item3: 'Películas',
            item4: 'Agregar Favoritos',
            disclaimer: 'Asegúrate de pedir ayuda de un adulto para continuar.',
            cta: 'INGRESA',
            skip: 'Sigue explorando',
        },
        drawer: {
            cta: 'Iniciar Sesión',
        },
        bottomSheet: {
            title: 'MÁS CONTENIDO',
            subtitle: 'Con tu cable operador',
        },
    },
    downloadApp: {
        title: 'Descarga la aplicación.',
        text1:
            'Para una mejor experiencia, te recomendamos descargar la aplicación.',
        text2:
            '¡Descarga la aplicación ahora y asegúrate diversión para toda tu familia!',
        text3:
            'Por favor, verifíca la disponibilidad con tu operador de cable o proveedor.',
    },
    unsupported:
        'Aún no soportamos este navegador. Por favor, utilice Google Chrome o Firefox.',
    cast: {
        connectTo: 'Conectar a',
        connectingTo: 'Conectando a',
        connectedTo: 'Conectado a',
        castingTo: 'Transmitiendo a ',
        disconnect: 'Desconectar',
    },
    smartBanner: {
        text: 'Mejora tu experiencia usando la app',
        cta: 'ABRA APP',
    },
    smartBannerV2: {
        text: 'Mejora tu experiencia',
        cta: 'Descarga la app',
    },
    pickAndPlace: {
        comingSoon: 'PRÓXIMAMENTE',
        live: 'AO VIVO AGORA',
    },
    playerui: {
        replay: {
            title: 'VER VIDEO DE NUEVO',
            nextTimer: 'El siguiente video comienza en ',
        },
        settings: {
            title: 'Configuraciones',
            qualityTitle: 'Calidad de video',
            qualities: {
                low: 'Baja',
                med: 'Media',
                high: 'Alta',
            },
            languageTitle: 'Idioma',
            languages: {
                por: 'Portugués',
                spa: 'Español',
                eng: 'Ingles',
            },
        },
    },
    games: {
        title: 'Juegos',
        featured: 'Destacados',
        allGames: 'Todos los juegos',
        recents: 'Recientemente jugado',
        playCTA: 'Jugar',
        exitModal: {
            title: '¿Salir del juego?',
            subtitle:
                'Si sales del juego ahora, podrías perder tu puntuación y tu progreso.',
            keepPlaying: 'Sigue jugando',
            exitGame: 'Salir',
        },
        ad: {
            disclaimer: 'Tu juego se cargará después de este anuncio...',
        },
        metaTitle: '¡Juega con tus personajes favoritos de Cartoon Network!',
        metaDescription:
            '¡Los juegos originales de Cartoon Network aquí mismo! ¡Enfréntate a desafíos, entra en aventuras y juega a los mejores juegos en línea con personajes que conoces y amas, como Gumball, Ben 10 y más!',
    },
    ads: {
        unmute: 'Reproducir sonido',
        mute: 'Sin sonido',
    },
    player: {
        offline: {
            title: 'Oops!',
            message: 'Comprueba tu conexión a Internet y vuelve a intentarlo.',
            cta: 'Intentar nuevamente',
        },
    },
    cartoonito: {
        landing: {
            title: '¡LLEGA CARTOONITO!',
            message:
                'Cartoonito, un nuevo destino preschool que lanza de la mano de Cartoon Network, llega a Latinoamérica con nuevos shows exclusivos, franquicias globales, producciones locales y todo el mejor contenido para los mas chiquitos de la familia.\nCartoonito es el lugar donde niños y niñas podrán expandir sus limites, reírse a carcajadas y disfrutar de personajes e historias entrañables.',
            comingSoon: '¡MUY PRONTO!',
            cta: 'PROGRAMACIÓN',
        },
        programming: {
            title: `PROGRAMACIÓN`,
            yesterday: 'Ayer',
            today: 'Hoy dia',
            tomorrow: 'Mañana',
            yearOfProduction: 'Ano de produccion',
            genres: 'Géneros',
            director: 'El director',
            cast: 'El elenco',
        },
        header: {
            cnappCTA: 'Ir a la CN APP',
        },
        cartoons: {
            title: 'Cartoons',
            metaTitle: 'Dibujos y series de Cartoonito',
            metaDescription:
                '¡Tus dibujos animados favoritos como Pocoyo, Thomas and Friends! Nuevos lanzamientos y cortos de Cartoonito!',
        },
        games: {
            title: 'Juegos',
            metaTitle:
                '¡Juegos para niños con tus personajes favoritos de Cartoonito!',
            metaDescription:
                'Una área de juegos online segura y educativa para los más pequeños. Los mejores juegos como lo juego de memoria con Cartoonito',
        },
        cta: {
            title: 'Una nueva experiencia está llegando',
            button: 'Descubrir',
        },
        live: {
            title: 'En vivo',
        },
        videos: {
            title: 'Videos',
            metaTitle:
                'Cartoonito! Dibujos y actividades para niños pequeños por Cartoon Network.',
            metaDescription:
                '¡Tus personajes favoritos están aquí! ¡Juega con la Lucas the Spider, Wee Boom y Odo. Consulta la programación y divirtase! ¡Vamos!',
        },
    },
    liveCarousel: {
        title: 'Jugando ahora',
        live: 'En vivo',
    },
    onboarding: {
        title: 'ELEGIR AVATAR',
        done: 'hecho',
        skip: 'saltar',
    },
    parentalPage: {
        title: 'Para Padres',
        back: 'Volver a',
        metaTitle: 'Cartoonito para padres! ¡Actividades familiares!',
        metaDescription:
            'Encuentra aquí las mejores actividades preescolares de los personajes favoritos de los más pequeños, para printar, colorir y jugar',
        welcome: {
            title: 'Bienvenido',
            subtitle:
                'Hay un lugar para los mas pequeños, ¡y todos están invitados! Vamos a reír, jugar, cantar, y divertirnos mucho juntos en Cartoonito. Nuestra filosofía Humancentric Learning, enfatiza la curiosidad, empatía, creatividad y coraje en todos nuestros shows.',
        },
        overview: {
            title: 'General',
            learningActivities: 'Actividades',
            learningActivitiesDescription:
                'Actividades para imprimir que van ayudar a los niños a aprender, jugar y crecer. ',
            learningActivitiesCTA: 'Ver Actividades',
            privacyPolicy: 'Política de Privacidad',
        },
        activities: {
            title: 'Actividades',
            disclaimer: 'Más actividades pronto',
            openCTA: 'Descargar',
            moreLine1: 'Más',
            moreLine2: 'actividades',
            moreLine3: 'pronto',
        },
        waysToWatch: {
            title: 'Como mirar',
            subtitle: 'Mas maneras de ver y jugar con Cartoonito',
            hboSubtitle: 'Mira ahora',
            watchOnTV: 'TELEVISIÓN',
            tvSubtitle: 'Mira la programación',
            cnitoSubtitle: 'descargar la aplicación en',
            disclaimer:
                'Algunos shows solo están disponibles en el canal de televisión de Cartoonito o en HBO Max. Revisa su disponibilidad.',
        },
        settings: {
            title: 'Configuración',
            subtitle: 'Controla lo que tus hijos miran y usan',
            notifications: {
                title: 'Notificaciones',
                subtitle:
                    'Cartoon Network puede notificar a tu hijo sobre los últimos shows y otros servicios en tu telefono o tablet.',
                text: 'Acepto recibir notificaciones push.',
            },
            mobileData: {
                title: 'Datos móviles',
                subtitle:
                    'Los videos pueden ser reproducidos por Wi-Fi o Datos Móviles. A través de Datos móviles pueden generar costo adicional en su factura.',
                text: 'Habilitar reproducción con Datos Móviles',
            },
        },
        newsletter: {
            homeTitle: 'Permanecer en el bucle',
            homeSubtitle:
                'Suscríbase a nuestro boletín y reciba actualizaciones mensuales de Cartoonito.',
            homeCTA: 'Suscribir',
            homeNew: 'Soy nuevo!',
            areaTitle: 'Newsletter',
            title: '¡Las últimas actualizaciones para ti!',
            news: 'Novedades en productos Cartoonito',
            educational: 'Contenido educativo para tus hijos',
            games: 'Juegos y actividades por correo',
            email: 'Email',
            ageCheck: 'Has confirmado que eres mayor de 18 años',
            privacyCheck:
                'Usted acepta recibir actualizaciones, noticias, avisos, y ofertas de Cartoonito y sus afiliados de WarnerMedia y Discovery reconoce que ha leído y acepta nuestra <u>Política de privacidad<u>',
            privacyCheckArgentina:
                'Usted acepta recibir actualizaciones, noticias, avisos, y ofertas de Cartoonito y sus afiliados de WarnerMedia y reconoce que ha leído y acepta nuestra <u>Política de privacidad<u>.',
            cta: 'Subscribe',
            disclaimer:
                'Para cancelar en cualquier momento o para obtener más información sobre sus derechos, consulte las opciones disponibles en la <underline>Política de privacidad</underline> y los <underline>Términos de uso</underline>.',
            subscribedConfirmationTitle: '¡Sí, estás suscrito!',
            subscribedConfirmationSubtitle:
                '¡Mantén un ojo en tu bandeja de entrada!',
        },
    },
    comics: {
        title: 'Comics',
        continueReading: 'Continuar leyendo',
        newChapters: 'Nuevos Capítulos',
        allComics: 'Todos los Comics',
        allChapters: 'Todos los Capítulos',
        chapter: 'Capítulo',
        about: 'Acerca de',
        followTitle: 'Sigue este Comic para ser notificado de nuevas historias',
        followButton: 'Seguir',
        followingTitle:
            'SERÁS NOTIFICADO CUANDO UN NUEVO CAPÍTULO SEA PUBLICADO',
        followingButton: 'Seguir',
        moreComics: 'Más Comics',
        moreSoon: 'Muy\npronto',
        tutorial1:
            'Desliza hacia abajo para volver a la página principal, compartir este episodio con tus amigos, o cambiar de episodio',
        tutorial2:
            'Desliza hacia arriba para ver un botón que te lleve rapidamente al inicio',
        tutorial3:
            'Usa las flechas si quieres ir al capítulo anterior o siguiente',
        tutorial4:
            'Haz click aquí si necesitas volver al comienzo de la historia',
        tutorialClose: 'Cerrar',
        tutorialSkip: 'Saltar',
        previous: 'Anterior',
        next: 'Siguiente',
        share: 'Compartir',
        gotoChapter: 'Ir al capítulo {chapter}',
        spoiler: {
            title: 'ALERTA DE SPOILER',
            description:
                'El último capítulo que leíste es el capítulo {chapter}',
            cta: 'Ir al capítulo {chapter}',
            continue: 'Quiero continuar al capítulo {chapter}',
        },
        read: 'Leer',
        readNow: 'Lee ahora',
        chapterRead0: 'Sin capítulos leídos',
        chapterRead1: '1 capítulo leído',
        chapterRead2: '{count} capítulos leídos',
    },
    search: {
        placeholder: 'Buscar',
        recommended: 'Búsquedas recomendadas',
        didYouMean: '¿Quisiste decir?',
        noResultAlert: '¡Oh no!',
        noResultTitle: 'No pudimos encontrar lo que buscas',
        checkLatest: '¡Mira los últimos clips!',
        help: 'Busca un show\no un juego',
    },
    push: {
        idleTitle:
            'Sigue a nuestro sitio para ser notificado de nuevos videos, juegos y cómics',
        idleSubtitle:
            'Asegúrate de preguntarle a tus padres si puedes ver esto, ¿OK?',
        idleCTA: 'Sigue a Cartoon Network',
        followingTitle:
            'Serás notificado de nuevos videos, juegos y cómics cuando los tengamos',
        followingSubtitle:
            'Para desactivar las notificaciones, entra a la configuración de tu navegador',
        followingCTA: 'Siguiendo a Cartoon Network',
    },
    dkids: {
        playArea: 'Area de Juegos',
        homeRow: 'Educational',
        trending: 'Más jugados',
        footerProgramming: 'Programación',
        copyright:
            'El uso de este sitio web implica que usted acepta los Términos de Uso. TM & © 2023 Discovery Kids. Una compañía de Warner Bros Discovery. Todos los derechos reservados.',
    },
    ageRating: {
        title: 'Clasificación de edad',
        subtitle:
            'Elija una clasificación de edad para que podamos filtrar nuestro contenido para su hijo.',
        age10: '10 años o menos',
        age12: '12 años o menos',
        all: 'Apto para todas las edades.',
        disclaimer:
            'Puedes cambiar esta opción en cualquier momento en la configuración de la aplicación.',
        cta: 'Confirmar',
        titleSuccess1: 'Muchas',
        titleSuccess2: 'Gracias',
        subtitleSuccess: 'Su preferencia ha sido establecida.',
        ctaSuccess: 'Okay',
    },
    stickers: {
        title: 'Descarga la aplicación.',
        latestStickers1: 'ÚLTIMO',
        latestStickers2: 'PAQUETE DE STICKERS',
    },
    sponsors: {
        gamesCTA: 'Ir a juegos',
        gameFooter: 'Juegos Cartoon Network',
        advertisement: 'Publicidad',
    },
};
